import {MILESTONE_COLLECTION} from '../../projects/domain/config';
import {getUpdateMilestone} from '../reducers/state';
import {makeEditMilestoneModal} from './configEditMilestoneRequests';
import {UPDATE_MILESTONE_PREFIX} from './state';


export const {
  /** @type {ReduxRequestModal} */
  requestModal: updateMilestoneRequestModal,
} = makeEditMilestoneModal({
  isUpdate: true,
  prefix: UPDATE_MILESTONE_PREFIX,
  getState: getUpdateMilestone,
  path: MILESTONE_COLLECTION,
});



// WEBPACK FOOTER //
// ./src/js/milestones/redux/updateMilestone.js